import { Socket } from 'socket.io-client'

export interface ClientCapability {
  /** 支持的 handler 命令列表 */
  commands: string[]
  /** 客户端版本 */
  version?: string
  /** 支持的特性标记 */
  features?: string[]
  /** 自定义元数据 */
  metadata?: Record<string, any>
}

/**
 * 客户端能力声明
 * 连接时上报支持的 handler 列表
 */
export class CapabilityReporter {
  private capability: ClientCapability
  private socket: Socket | null = null

  constructor(capability: ClientCapability) {
    this.capability = capability
  }

  /** 更新能力声明 */
  update(capability: Partial<ClientCapability>): void {
    if (capability.commands) this.capability.commands = capability.commands
    if (capability.version) this.capability.version = capability.version
    if (capability.features) this.capability.features = capability.features
    if (capability.metadata) this.capability.metadata = capability.metadata
    this.report()
  }

  /** 添加命令到能力列表 */
  addCommand(command: string): void {
    if (!this.capability.commands.includes(command)) {
      this.capability.commands.push(command)
      this.report()
    }
  }

  /** 移除命令 */
  removeCommand(command: string): void {
    const idx = this.capability.commands.indexOf(command)
    if (idx >= 0) {
      this.capability.commands.splice(idx, 1)
      this.report()
    }
  }

  /** 绑定 socket 并上报 */
  bind(socket: Socket): void {
    this.socket = socket
    this.report()
  }

  /** 获取当前能力 */
  getCapability(): ClientCapability {
    return { ...this.capability, commands: [...this.capability.commands] }
  }

  /** 检查是否支持某命令 */
  supports(command: string): boolean {
    return this.capability.commands.includes(command)
  }

  private report(): void {
    if (this.socket?.connected) {
      this.socket.emit('client:capability', this.capability)
    }
  }
}
